"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatValue = exports.getKey = exports.toMap = void 0;
const core_1 = require("@emotion/core");
const lodash_1 = require("lodash");
const common_utils_1 = require("@zapier/common-utils");
function toMap(data) {
    if (data instanceof Map) {
        return data;
    }
    if (data !== null && typeof data === 'object') {
        return new Map(Object.entries(data));
    }
    return new Map(Object.entries({ '': data }));
}
exports.toMap = toMap;
function getKey(key, isSimpleArrayValue) {
    return isSimpleArrayValue && lodash_1.isNumber(key) ? key + 1 : key;
}
exports.getKey = getKey;
function hasWhiteSpace(str) {
    return str.indexOf(' ') !== -1;
}
const Styles = common_utils_1.labelStyles(__filename, {
    getLineStyles(value) {
        return {
            wordBreak: hasWhiteSpace(value)
                ? 'break-word'
                : 'unset',
            lineHeight: 1.6,
        };
    },
});
function formatValue({ value, hasEmptyRequiredFields, hasEmptyOptionalFields, }) {
    if (!value) {
        if (hasEmptyRequiredFields) {
            return 'empty (required)';
        }
        if (hasEmptyOptionalFields) {
            return 'empty (optional)';
        }
    }
    return String(value)
        .split('\n')
        .map((line, i) => (core_1.jsx("div", { css: Styles.getLineStyles(line), key: i }, line)));
}
exports.formatValue = formatValue;
